<template>
  <div class="operation-stepper">
    <div
      v-for="(step, index) in steps"
      :key="step.key"
      class="operation-stepper__item"
    >
      <div class="operation-stepper__node" :class="getStepClass(step)">
        <span>{{ index + 1 }}</span>
      </div>
      <div class="operation-stepper__copy">
        <div class="operation-stepper__label">{{ step.label }}</div>
      </div>
      <div
        v-if="index < steps.length - 1"
        class="operation-stepper__line"
        :class="{ 'operation-stepper__line--done': isStepDone(step) }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationStepper",
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: String,
      default: null,
    },
  },
  methods: {
    getStepIndex(stepKey) {
      return this.steps.findIndex((step) => step.key === stepKey);
    },
    isStepDone(step) {
      return this.getStepIndex(step.key) < this.getStepIndex(this.currentStep);
    },
    getStepClass(step) {
      return {
        "operation-stepper__node--active": step.key === this.currentStep,
        "operation-stepper__node--done": this.isStepDone(step),
      };
    },
  },
};
</script>

<style scoped>
.operation-stepper {
  align-items: center;
  border-bottom: 1px solid #d6d6d6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
  display: flex;
  gap: 0;
  overflow-x: auto;
  padding: 24px 32px;
}

.operation-stepper__item {
  flex: 1 1 0;
  display: flex;
  align-items: center;
  min-width: 0;
  position: relative;
}

.operation-stepper__node {
  align-items: center;
  background: #eeeeee;
  border-radius: 50%;
  color: #757575;
  display: flex;
  flex: 0 0 32px;
  font-size: 13px;
  font-weight: 700;
  height: 32px;
  justify-content: center;
  margin-right: 10px;
}

.operation-stepper__node--active {
  background: #5e6ad2;
  color: #ffffff;
}

.operation-stepper__node--done {
  background: #5e6ad2;
  color: #ffffff;
}

.operation-stepper__copy {
  min-width: 0;
}

.operation-stepper__label {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.operation-stepper__line {
  background: #e0e0e0;
  height: 2px;
  margin: 0 18px;
  min-width: 52px;
  flex: 1 1 auto;
}

.operation-stepper__line--done {
  background: #5e6ad2;
}
</style>
